
import { defineComponent, ref } from "vue";
import ResourceResultsTable from "./components/ResourceResultsTable.vue";
import ResultsTable from "./components/ResultsTable.vue";
import RegexResultsTable from "./components/RegexResultsTable.vue";
import SitemapsTable from "./components/SitemapsTable.vue";
import { watcherService } from "./services/watcherService";
import HiddenErrorsTable from "./components/HiddenErrorsTable.vue";
import ResponseStatusCodesHelp from "./components/ResponseStatusCodesHelp.vue";

export default defineComponent({
	name: "App",
	components: {
		SitemapsTable,
		ResultsTable,
		ResourceResultsTable,
		RegexResultsTable,
		HiddenErrorsTable,
		ResponseStatusCodesHelp,
	},
	setup() {
		const tabs = [
			{ name: "pages", title: "Pages" },
			{ name: "resources", title: "Resources" },
			{ name: "regexes", title: "Regexes" },
			{ name: "hiddenErrors", title: "Hidden Errors" },
			{ name: "help", title: "Help" },
		] as const;
		const selectedTab = ref<typeof tabs[number]["name"]>("pages");

		const { watchResources, setWatchResources } = watcherService;
		const toggleWatchResources = () => {
			setWatchResources(!watchResources.value);
		};

		return {
			tabs,
			selectedTab,

			watchResources,
			toggleWatchResources,
		};
	},
});
